import { useMutation } from "@tanstack/react-query";
import { privateHttp } from "../../config/axios";
import { API_ENDPOINTS } from "../../config/endpoints";
import {
  TicketPaymentPreOrderRequest,
  TicketPaymentPreOrderResponse,
  TicketPaymentOrderConfirmRequest,
  TicketPaymentOrderConfirmResponse,
} from "~/types/common";

// 이용권 Pre Order API
const createTicketPreOrder = async (
  params: TicketPaymentPreOrderRequest[]
): Promise<TicketPaymentPreOrderResponse> => {
  try {
    const { data } = await privateHttp.post<TicketPaymentPreOrderResponse>(
      API_ENDPOINTS.TICKET_PAYMENT.PRE_ORDER,
      params
    );
    return data;
  } catch (error) {
    console.error("이용권 Pre Order API 호출 에러:", error);
    throw error;
  }
};

// 이용권 Order Confirm API
const confirmTicketOrder = async (
  params: TicketPaymentOrderConfirmRequest
): Promise<TicketPaymentOrderConfirmResponse> => {
  try {
    const { data } = await privateHttp.post<TicketPaymentOrderConfirmResponse>(
      API_ENDPOINTS.TICKET_PAYMENT.ORDER_CONFIRM,
      params
    );
    return data;
  } catch (error) {
    console.error("이용권 Order Confirm API 호출 에러:", error);
    throw error;
  }
};

// 이용권 Pre Order React Query Hook
export const useTicketPreOrder = () => {
  return useMutation({
    mutationFn: createTicketPreOrder,
  });
};

// 이용권 Order Confirm React Query Hook
export const useTicketOrderConfirm = () => {
  return useMutation({
    mutationFn: confirmTicketOrder,
  });
};

